import React from "react";

import { ReactComponent as Previous } from "../assets/icons/previous.svg";
import { ReactComponent as Next } from "../assets/icons/next.svg";

export default function Pagination({ data, query }) {
  let pages = data.count ? Math.floor(data.count / data.size) : 0;
  let inicial = data ? data.page : 0;
  if (!data.first) {
    inicial = inicial - 1;
  }
  let fim = inicial + 5 > pages ? pages : inicial + 5;
  if (!data.count) {
    inicial = 0;
    fim = 0;
  }
  let p = Array.from({ length: fim - inicial }, (_, i) => i + inicial);
  if (p.length === 0 && data.count) {
    p = [data.page];
  }
  if (fim !== pages) {
    p.push("...");
    p.push(pages);
  }
  return (
    <div className="flex justify-center items-center gap-4">
      <button onClick={() => query(data.first ? data.page : data.page - 1)}>
        <Previous
          className={`w-4 h-4 ${
            data.first ? "stroke-disabled" : "stroke-primary"
          }`}
        />
      </button>
      {p.map((i) => (
        <button key={"kp" + i} onClick={() => query(i)}>
          <div
            className={`flex justify-center items-center w-8 h-8 border-2 border-active font-bold ${
              data.page === i ? "text-primary" : "text-white"
            }`}
          >
            {i === "..." ? i : i + 1}
          </div>
        </button>
      ))}
      <button onClick={() => query(data.last ? data.page : data.page + 1)}>
        <Next
          className={`w-4 h-4 ${
            data.last ? "stroke-disabled" : "stroke-primary"
          }`}
        />
      </button>
    </div>
  );
}
